<template>
  <v-container>
    <v-row>
      <v-col>
        <p class="custom-text text-left black--text">
          {{ policyComponent.title }}
        </p>
        <p class="custom-text text-left black--text">
          {{ policyComponent.description }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <Button
          :text="policyComponent.confirmText"
          @click="() => setPrivacyValue('true')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions,} from 'vuex';
import Button from '@/components/Button';
import { mapGetters, } from 'vuex';

export default {
  name: 'PolicyComponent',
  components: {
    Button,
  },
  props: {
    language: {
      type:String,
      default: 'IT',
    },
  },
  computed: {
    ...mapGetters(['policy',],),   
    policyComponent: {
      get() {
        return this.policy(this.language,);
      },
    },
  },
  methods: {
    ...mapActions({
      setPrivacy: 'setPrivacy',
    },),
    setPrivacyValue(accepted,) {
      this.setPrivacy(accepted,);
    },
  },
};
</script>
